import { render } from "./field-edit.vue?vue&type=template&id=b452e5e0&scoped=true"
import script from "./field-edit.vue?vue&type=script&lang=js"
export * from "./field-edit.vue?vue&type=script&lang=js"

import "./field-edit.vue?vue&type=style&index=0&id=b452e5e0&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\YCTECH\\ycform\\trunk\\ycform-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b452e5e0"]])

export default __exports__